import React from "react";
import Grid from "@mui/material/Grid";
import {useDispatch, useSelector} from "react-redux";
import PackageAttachments from "../package-attachments";
import PackageEditButton from "../package-manager/PackageEditButton";
import PackageTitle from "../package-title";
import {clearCatalog} from "../../state/catalog/catalogActions";
import {nodeIdSelector, nodeSelector} from "../../state/node/nodeSelectors";

const Header = ({categoryPath, packageId, packageTitle, packageApproved, attachments}) => {
  const dispatch = useDispatch();

  const node = useSelector(nodeSelector);
  const nodeId = useSelector(nodeIdSelector);

  return (
    <PackageTitle
      id="package-viewer__header"
      categoryPath={categoryPath}
      packageId={packageId}
      packageTitle={packageTitle}
      packageApproved={packageApproved}
      actions={
        <Grid container alignItems="center">
          <Grid id="package-viewer__header__actions__attachments-btn">
            <PackageEditButton
              withIcon
              nodeId={nodeId}
              nodeType={node?.type}
              packageId={packageId}
              callback={() => dispatch(clearCatalog())}
            />
          </Grid>
          <Grid id="package-viewer__header__actions__attachments-btn">
            <PackageAttachments packageId={packageId} attachments={attachments} />
          </Grid>
        </Grid>
      }
    />
  );
};

export default Header;
